















































































































import { Vue, Component } from "vue-property-decorator";
import { FooterInfo } from "@/general/store/models";
import commons from "@/common/store/modules/commons";
import { getFooterInfo } from "@/general/store/api";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Component({
  name: "TheFooter",
})
export default class TheFooter extends Vue {
  footers: FooterInfo = {} as FooterInfo;
  footer_hidden_flag = false;

  get companyCd() {
    let companyCode: string = auth.user.company_code;
    if (companyCode == null) {
      const userDetailJson = LocalStorage.getItem("userDetails");
      if (userDetailJson) {
        const userDetail = JSON.parse(userDetailJson);
        companyCode = userDetail.company_code;
      }
    }
    return companyCode;
  }

  get host(): any {
    return process.env.VUE_APP_BS_DOMAIN;
  }

  get urls() {
    return {
      travelAgencyLaw: `${this.host}/contents/kiyaku/travel_agency_law/`,
      privacyPolicy: `${this.host}/contents/kiyaku/privacy/`,
      enquiryLink: `${this.host}/contents/cgi/memberfaqic/index.html`
    };
  }

  get termsUrl(): string {
    return `${process.env.VUE_APP_API_DOMAIN}/api/terms_of_use_doc`;
  }

  async created() {
    const path = location.pathname;
    console.debug(path);
    // logoutはSSOログアウト専用、session-time-outはだし分けが必要だが、
    // フッターを表示するのはSSOの場合のみなので、フッター表示をSSOに合わせて変更して問題なし
    const NO_FOOTER_URL = ["/logout/", "/session-time-out/"];

    let footer = null;

    // 非認証画面で、認証が必要なリクエストが飛ばないための分岐
    if (NO_FOOTER_URL.includes(path)) {
      this.footer_hidden_flag = true;
    } else {
      footer = await getFooterInfo(this.companyCd);
      await commons.setFooter(footer);
    }

    if (!footer) {
      return {
        department_name: "",
        email_address: "",
        telephone_number: "",
        membership_term_url: "",
        display_department_name: false,
        display_email_address: false,
        display_telephone_number: false,
        site_id: ""
      };
    }

    footer.membership_term_url =
      footer.membership_term_url === null
        ? `https://icpt-ric.tst.benefit-one.inc/static/profiles/files/standard_agreement.docx`
        : footer.membership_term_url;
    this.footers = footer;
  }
  get displayEmail() {
    return this.footers.display_email_address;
  }
  get displayTel() {
    return this.footers.display_telephone_number;
  }
  get displayDepartmentName() {
    return this.footers.display_department_name;
  }

  get checkSelectContractFlag() {
    const selectContractFlag = LocalStorage.getItem("selectContractFlag");
    return selectContractFlag;
  }

  get checkExpiredContractDate() {
    const expiredContractDateFlag = LocalStorage.getItem(
      "expiredContractDateFlag"
    );
    return expiredContractDateFlag;
  }

  get checkNotContractedIc() {
    const notContractedIc = LocalStorage.getItem("notContractedIc");
    return notContractedIc;
  }
}
